import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/roles"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);

export const rolesApi = createApi({
    reducerPath: "rolesApi",
    baseQuery: baseQueryWithRejection,
    tagTypes: [],
    endpoints: (builder) => ({
        getRoles: builder.query({
            query: (params) => {
                const tmp = new URLSearchParams();
                if (params?.withoutUsers) {
                    tmp.append("without-users", params?.withoutUsers);
                }
                if (params?.only) {
                    tmp.append("only", params?.only);
                }
                if (params?.fields) {
                    tmp.append("fields", params?.fields);
                }
                return `/?${tmp.toString()}`;
            },
            transformResponse: (response) => response.data,
            providesTags: [],
        }),
        getRoleById: builder.query({
            query: ({ id, params }) => {
                params = params ?? {};
                const tmp = new URLSearchParams();
                for (const x in params) {
                    tmp.append(x, params[x]);
                }
                return `/${id}?${tmp.toString()}`;
            },
            transformResponse: (response) => response.data,
            providesTags: [],
        }),
    }),
});

export const { useGetRolesQuery, useGetRoleByIdQuery, useLazyGetRolesQuery } = rolesApi;
